import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "layout-topbar" }
const _hoisted_2 = { class: "layout-topbar-wrapper" }
const _hoisted_3 = { class: "layout-topbar-left" }
const _hoisted_4 = { class: "menu-wrapper layout-sidebar-active" }
const _hoisted_5 = { class: "sidebar-logo" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "layout-menu-container" }
const _hoisted_9 = { class: "mx-4 my-2 text-xs text-gray-500 font-semibold" }
const _hoisted_10 = { class: "mx-4 my-2 text-xs text-gray-500 font-semibold" }
const _hoisted_11 = { class: "mx-4 my-2 text-xs text-gray-500 font-semibold" }
const _hoisted_12 = { class: "mx-4 my-2 text-xs text-gray-500 font-semibold" }
const _hoisted_13 = { class: "layout-topbar-right" }
const _hoisted_14 = { class: "layout-topbar-actions" }
const _hoisted_15 = { class: "topbar-item" }
const _hoisted_16 = {
  key: 0,
  class: "mr-4"
}
const _hoisted_17 = { class: "text-xs text-gray-300" }
const _hoisted_18 = { class: "text-sm text-blue-500" }
const _hoisted_19 = { class: "text-xs text-gray-300" }
const _hoisted_20 = {
  key: 0,
  class: "ml-2 cursor-pointer"
}
const _hoisted_21 = { class: "text-sm text-gray-500" }
const _hoisted_22 = { class: "layout-rightpanel-button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TopBarMenu = _resolveComponent("TopBarMenu")!
  const _component_IconPark = _resolveComponent("IconPark")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", {
          class: "menu-button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onMenuButtonClick && _ctx.onMenuButtonClick(...args)))
        }, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("i", { class: "pi pi-bars" }, null, -1)
        ]))])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_ctx.themeIsLight && _ctx.project.logo_url_black)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "w-full",
                src: _ctx.project.logo_url_black
              }, null, 8, _hoisted_6))
            : _createCommentVNode("", true),
          (_ctx.themeIsDark && _ctx.project.logo_url_white)
            ? (_openBlock(), _createElementBlock("img", {
                key: 1,
                class: "w-full",
                src: _ctx.project.logo_url_white
              }, null, 8, _hoisted_7))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_TopBarMenu, {
            class: "layout-menu",
            "menu-items": _ctx.menuItemsCommonTop
          }, null, 8, ["menu-items"]),
          (_ctx.user.isStaff())
            ? (_openBlock(), _createBlock(_component_TopBarMenu, {
                key: 0,
                class: "layout-menu",
                "menu-items": _ctx.filteredMenuItemsStaff
              }, null, 8, ["menu-items"]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_ctx.user.ui_publisher_direct || _ctx.user.ui_publisher_rtb)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('publisher')), 1),
                      _createVNode(_component_TopBarMenu, {
                        class: "layout-menu",
                        "menu-items": _ctx.menuItemsPublisher
                      }, null, 8, ["menu-items"])
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.user.ui_advertiser)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('advertiser')), 1),
                      _createVNode(_component_TopBarMenu, {
                        class: "layout-menu",
                        "menu-items": _ctx.menuItemsAdvertiser
                      }, null, 8, ["menu-items"])
                    ], 64))
                  : _createCommentVNode("", true)
              ], 64)),
          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('main')), 1),
          _createVNode(_component_TopBarMenu, {
            class: "layout-menu",
            "menu-items": _ctx.menuItemsCommonBottom
          }, null, 8, ["menu-items"]),
          (_ctx.user.ui_referrer)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('promo')), 1),
                _createVNode(_component_TopBarMenu, {
                  class: "layout-menu",
                  "menu-items": _ctx.menuItemsReferrer
                }, null, 8, ["menu-items"])
              ], 64))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("ul", _hoisted_14, [
          _createElementVNode("li", _hoisted_15, [
            (_ctx.user.ui_advertiser)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('balance')), 1),
                  _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$n(_ctx.user.balance, 'payout')), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('email')), 1),
                (_ctx.user.isStaff())
                  ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_20, [
                      _createTextVNode(_toDisplayString(_ctx.USER_TYPES_MAP[_ctx.user.type].emoji), 1)
                    ])), [
                      [
                        _directive_tooltip,
                        _ctx.$t(_ctx.USER_TYPES_MAP[_ctx.user.type].translate_key),
                        void 0,
                        { bottom: true }
                      ]
                    ])
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.user.email), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _withDirectives((_openBlock(), _createBlock(_component_IconPark, {
            class: "cursor-pointer",
            key: _ctx.themeIsLight,
            type: _ctx.themeIsLight ? 'moon' : 'sun',
            theme: "outline",
            size: "16",
            onClick: _ctx.toggleTheme
          }, null, 8, ["type", "onClick"])), [
            [
              _directive_tooltip,
              _ctx.themeIsLight ? _ctx.$t('dark_theme') : _ctx.$t('light_theme'),
              void 0,
              { top: true }
            ]
          ])
        ]),
        _createElementVNode("a", {
          class: "layout-rightpanel-button",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
        }, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("i", { class: "pi pi-sign-out" }, null, -1)
        ]))])
      ])
    ])
  ]))
}